import dayjs from "dayjs";

// Only the scheduling columns are worth ordering. Sorting Remarks, Updated By
// or Status alphabetically does not tell a nurse anything useful, so those
// headers stay plain.
const SORTABLE_COLUMNS = new Set([
  "process_time", // Time Done / Start Time
  "end_time",
  "start_time",
  "action_time", // Schedule
  "schedule",
]);

const timeValue = (value) => {
  if (!value) return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.valueOf() : null;
};

// Times are compared as timestamps, never as text — otherwise "9:05 AM" would
// sort after "10:00 AM".
const compareTime = (a, b) => {
  const left = timeValue(a);
  const right = timeValue(b);
  // Rows with no time yet group together at one end rather than interleaving.
  if (left === null && right === null) return 0;
  if (left === null) return -1;
  if (right === null) return 1;
  return left - right;
};

export const careColumnSorter = (dataIndex) => (a, b) =>
  compareTime(a?.[dataIndex], b?.[dataIndex]);

// Adds a sorter to the time columns of a care-item table. A table showing a
// single entry has nothing to order, so the arrows are left off there — they
// would be a control that cannot change anything. Any column can opt out with
// `sorter: false`.
export const withCareSorters = (columns, rows) => {
  const sortable = Array.isArray(rows) && rows.length > 1;

  return columns.map((col) => {
    if (!col?.dataIndex || col.sorter === false) return col;
    if (!sortable || !SORTABLE_COLUMNS.has(col.dataIndex)) {
      const { sorter, defaultSortOrder, ...rest } = col;
      return rest;
    }
    return {
      ...col,
      sorter: col.sorter || careColumnSorter(col.dataIndex),
      showSorterTooltip: false,
    };
  });
};

export default withCareSorters;
